import React, { Component } from 'react';
import moment from 'moment';
import ModalAlteracoes from '../Modal-Alteracoes/Modal-Alteracoes';


class HeaderProduto extends Component {
    constructor(props) {
        super(props);

        this.voltar = this.voltar.bind(this);
        this.toggleModalAlteracoes = this.toggleModalAlteracoes.bind(this);
        this.state = {
            modalAlteracoes: false,
        };
    }

    voltar() {
        const _infosProduto = {
            ...this.props.produto,
            dtLancamento: this.props.produto.dtLancamento,
            // promocoes: this.state.promocoes,
        };
        const mesmaVersao = JSON.stringify(this.props.versaoAtual) === JSON.stringify(_infosProduto);
        if (!mesmaVersao) this.toggleModalAlteracoes();
        else window.history.go(-1);
    }

    toggleModalAlteracoes() {
        this.setState({ modalAlteracoes: !this.state.modalAlteracoes })
    }

    render() {
        return (
            <div className="header-cadastro border-left border-bottom border-gray">
                <div className="row no-gutters py-3 align-items-center">
                    <div className="col-7 px-3">
                        {!this.props.novoProduto ? (
                            [<p key={1} className="m-0">Status: <span className={`badge badge-${this.props.produto.ativo ? 'success' : 'secondary badge-opacity'}`}>{this.props.produto.ativo ? 'Ativo' : 'Inativo'}</span>
                            </p>,
                            <p key={2} className="m-0">Última modificação: {moment(this.props.produto.dtModificacao).format("DD/MM/YYYY H:mm:ss")}
                            </p>]
                        ) : (
                                <p key={1} className="m-0">Status: <span className={`badge badge-secondary badge-opacity`}>Novo produto</span>
                                </p>
                            )}
                    </div>
                    {this.props.novoProduto ? (
                        <div className="col-5 text-right px-3">
                            {this.props.isLoadingAlteracoes ? (
                                <div className="spinner-border spinner-border-sm mx-5 text-primary" role="status" />
                            ) : (
                                    <button onClick={this.props.salvarAlteracoes} className="btn btn-outline-success mx-1 mr-5">{'salvar produto'}</button>
                                )}
                            <button onClick={this.voltar} className="btn btn-outline-secondary mx-1">voltar</button>
                        </div>
                    ) : (
                            <div className="col-5 px-3">

                                <div className="row no-gutters">
                                    <div className="col-5 text-right">
                                        {this.props.isLoadingAlteracoes ? (
                                            <div className="spinner-border spinner-border-sm mx-5 text-primary" role="status" />
                                        ) : (
                                                <button onClick={this.props.salvarAlteracoes} className="btn btn-outline-success mx-1">{'salvar alterações'}</button>
                                            )}
                                    </div>
                                    <div className="col-5 text-center">
                                        {this.props.produto.ativo && !this.props.isLoadingStatus ? (
                                            <button onClick={() => this.props.mudaStatusProduto("desativar")} className="btn btn-outline-danger mx-1">desativar produto</button>
                                        ) : null}
                                        {!this.props.produto.ativo && !this.props.isLoadingStatus && (
                                            <button onClick={() => this.props.mudaStatusProduto("ativar")} className="btn btn-outline-primary mx-1">ativar produto</button>
                                        )}
                                        {this.props.isLoadingStatus && (
                                            <div className="spinner-border spinner-border-sm mx-5 text-primary" role="status" />
                                        )}
                                    </div>
                                    <div className="col-2 text-right">
                                        <button onClick={this.voltar} className="btn btn-outline-secondary mx-1">voltar</button>
                                    </div>
                                </div>
                            </div>
                        )}
                </div>
                <ModalAlteracoes
                    isOpen={this.state.modalAlteracoes}
                    toggle={this.toggleModalAlteracoes}
                />
            </div>
        );
    }
}

export default HeaderProduto;